module.exports = __webpack_public_path__ + "3a75e5a744a4e2d90bd700a0d17656a6.png";